import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingButton } from "@mui/lab";
import { Grid } from "@mui/material";
import { Card, CardActions } from "@ssf/components";
import { Account } from "mdi-material-ui";
import { MemberForm, useMemberForm } from "./index.js";
export const MemberFormCard = ({ title, description, action, schema, member: initialMember, onDupe, onSubmit, isLoading, backButton, formSchema = schema, }) => {
    const formFieldProps = useMemberForm(schema, {
        defaultValues: initialMember,
    });
    return (_jsxs("form", { onSubmit: formFieldProps.handleSubmit(onSubmit), children: [_jsxs(Card, { icon: _jsx(Account, {}), title: title, children: [description, _jsx(Grid, { container: true, spacing: 2, children: _jsx(MemberForm, { schema: formSchema, onDupe: onDupe, ...formFieldProps }) })] }), _jsx(CardActions, { backButton: backButton, children: _jsx(LoadingButton, { type: "submit", variant: "contained", loading: isLoading, children: action }) })] }));
};
//# sourceMappingURL=MemberFormCard.js.map